import type { OfflineDb } from './dexie/offline-db.js';

// Generic KvStore port implementation (design §5) over the Dexie `kv` table.
// Deliberately untyped at this layer (`unknown` in, `unknown` out) — callers
// own their own schema validation (e.g. offline-profile.ts validates against
// OfflineProfileSchema before trusting a read). Keeping this port generic
// means slice 6/7 can reuse it for suspendedKnownAt, rq-cache, lastSyncAt,
// persistGranted (design §5 kv table content) without touching this file.
export class DexieKvStore {
  constructor(private readonly db: OfflineDb) {}

  async get(key: string): Promise<unknown> {
    const row = await this.db.kv.get(key);
    return row?.value;
  }

  async set(key: string, value: unknown): Promise<void> {
    await this.db.kv.put({ key, value });
  }

  async remove(key: string): Promise<void> {
    await this.db.kv.delete(key);
  }
}
